module.exports = __webpack_public_path__ + "img/carup.8974b70a.png";